export default class BrixTabMenu {
  static init(...parameters) {
    return new BrixTabMenu(...parameters);
  }

  constructor(selector) {
    this.selector = selector;
    this.mobileView = false;

    const mobileView = () => {
      this.tabmenu = selector.querySelector('.tab-menu');
      this.openButton = selector.querySelector('.open-close-dropdown');

      const updateMobileMenuButton = () => {
        this.text = selector.querySelectorAll('.-current');
        let newValue;
        [...this.text].forEach((item) => {
          if (item.classList.contains('menu-item')) {
            newValue = item.innerText.trim();
          }
        });
        this.text = selector.querySelector('.menu-text');
        if (newValue) {
          this.text.innerText = newValue;
        } else {
          this.text.innerText = 'menu';
        }
        this.tabmenu.classList.add('-closed');
        this.tabmenu.classList.remove('-open');
        this.openButton.classList.add('-up');
        this.openButton.classList.remove('-down');
      };

      updateMobileMenuButton();

      const openMobileMenu = () => {
        if (this.openButton.classList.contains('-up')) {
          this.tabmenu.classList.add('-open');
          this.tabmenu.classList.remove('-closed');
          this.openButton.classList.add('-down');
          this.openButton.classList.remove('-up');
        } else {
          this.tabmenu.classList.add('-closed');
          this.tabmenu.classList.remove('-open');
          this.openButton.classList.add('-up');
          this.openButton.classList.remove('-down');
        }
      };
      this.openButton.addEventListener('click', () => openMobileMenu());
      this.tabmenu.addEventListener('click', event => updateMobileMenuButton(event));
    };


    if (window.innerWidth < 768) {
      //  First render if page is mobile to get top menu name
      if (!this.mobileView) {
        this.mobileView = true;
        mobileView();
      }
    }

    window.addEventListener('resize', () => {
      // Render on resize to check if window innerheight is below 768px a.k.a mobile view
      if (window.innerWidth < 768) {
        if (!this.mobileView) {
          this.mobileView = true;
          mobileView();
        }
      }
    });

    if (!this.selector.classList.contains('-no-reload')) {
      return;
    }

    this.menu = selector.querySelectorAll('.menu-item');
    this.tabs = selector.querySelectorAll('.tab');

    [...this.menu].forEach((item) => {
      item.addEventListener('click', event => this.handleMenuClick(event));

      if (window.location.hash === `#${item.dataset.hash}`) {
        const scrollToElement = selector.querySelector(`.${selector.id}-anchor-${item.dataset.hash}`);
        if (scrollToElement) {
          setTimeout(() => {
            scrollToElement.scrollIntoView();
          }, 200);
        }

        this.setCurrent(item.dataset);
      }
    });

    window.addEventListener('hashchange', () => {
      [...this.menu].forEach((item) => {
        if (window.location.hash === `#${item.dataset.hash}`) {
          this.setCurrent(item.dataset);
        }
      });
    });
  }

  handleMenuClick(event) {
    this.setCurrent(event.target.dataset);
  }

  setCurrent(dataset) {
    if (window.location.hash !== dataset.hash) {
      window.location.hash = dataset.hash;
    } else {
      window.location.hash = '';
    }

    [...this.menu].forEach((item) => {
      if (item.dataset.id === dataset.id) {
        item.classList.add('-current');
      } else {
        item.classList.remove('-current');
      }
    });
    [...this.tabs].forEach((tab) => {
      if (tab.dataset.id === dataset.id) {
        tab.classList.add('-current');
      } else {
        tab.classList.remove('-current');
      }
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-tab-menu', BrixTabMenu.init);
}
